<!-- src/App.vue -->
<script setup lang="ts">
import { RouterView } from "vue-router";
import HeaderComponent from "@/components/layout/JourneyHeader/JourneyHeader.vue";
import FooterComponent from "@/components/layout/JourneyFooter/JourneyFooter.vue";
import { FOOTER_LINKS } from "@/constants/footerLinks";
import type { FooterLink } from "@/models/footerLinks.model";
import { useGenesys } from "@/composables/use-genesys";
import { useDataLayerScript } from "@/composables/use-datalayer-script";

const links: FooterLink[] = FOOTER_LINKS;
useGenesys();
useDataLayerScript();
</script>

<template>
    <div class="app-layout">
        <HeaderComponent />

        <main class="app-main">
            <RouterView />
        </main>

        <FooterComponent :links="links" />
    </div>
</template>

<style scoped>
.app-layout {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
}

.app-main {
    flex: 1;
    display: flex;
    flex-direction: column;
}
</style>
